import gql from 'graphql-tag';
import {resourceFragment} from './fragments';

export const resources = gql`
  query resources($where: ResourceWhereInput, $orderBy: ResourceOrderByInput, $skip: Int, $after: String, $before: String, $first: Int, $last: Int) {
    resources(where: $where, orderBy: $orderBy, skip: $skip, after: $after, before: $before, first: $first, last: $last) ${resourceFragment}
  }
`;
